import React, { useState, useContext, useEffect, useRef } from "react";
import BusinessContext from "context/BusinessContext";
import ReactStars from "react-rating-stars-component";
import Formatter from "hoc/Formatter";
import "suneditor/dist/css/suneditor.min.css";
import { connection } from "utils/apiConnection.ts";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import Product from "./Product";
import { CommentList } from "./Comments";
import CreateComment from "./Comments";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Creatable from "react-select/creatable";
import styles from "../profile/profile.module.css";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "./Slider.scss";
import sendRequest from "hooks/useAxios";
import "./SingleProduct.scss";
import EditProduct from "components/createModal/EditProduct";
import ax3 from "assets/images/imgdn.webp";
import Editor from "utils/Editor";
import SingleProductSlider from "./SingleProductSlider";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useParams } from "react-router";

const SingleProduct = ({ setLoader, setUpdater, updater }) => {
  const navigate = useNavigate();
  const params = useParams();
  const auth = useContext(WithAuthentication);
  const { product, products, bpid, comments, setProducts } =
    useContext(BusinessContext);

  const [slider, setSlider] = useState([]);
  const [allProductTags, setAllProductTags] = useState([]);
  const [valProductTags, setValProductTags] = useState("");
  const [localArticleData, setLocalArticleData] = useState({
    title: "",
    productId: "",
    description: "",
    score: "",
    cover: null,
    coverId: 0,
    hashtags: [],
    otherFiles: [],
    otherFilesId: 0,
  });

  const inputRef = useRef();
  const btnRef = useRef();
  // console.log("btnRef", btnRef.current);
  const changeHandleraTags = (option) => {
    setLocalArticleData((prev) => {
      let temp = { ...prev };
      temp.hashtags = option;
      return { ...temp };
    });
  };
  async function changeHandlerImg(e) {
    setLocalArticleData({
      ...localArticleData,
      [e.target.name]: e.target.files[0],
    });
    let result = await connection("uploadfiles", {
      "files[]": e.target.files[0],
    });
    setLocalArticleData((prev) => {
      return { ...prev, [e.target.name + "Id"]: result.result[0].id };
    });
  }
  const changeHandlerLogo = (e) => {
    let myFormData = new FormData();
    for (let i = 0; i < e.target.files.length; i++) {
      myFormData.append("files[]", e.target.files[i]);
    }
    axios
      .post("http://tatclub.tatdemo.ir/api/uploadfiles", myFormData)
      .then((res) => {
        setLocalArticleData({
          ...localArticleData,
          otherFiles: e.target.files,
          otherFilesId: res.data.result,
        });
      })
      .catch((err) => console.log(err));
  };
  const changeHandler = (type, value) => {
    setLocalArticleData((prev) => {
      return { ...prev, [type]: value };
    });
  };

  useEffect(() => {
    async function loadPage() {
      let result = await connection("Find_ProductTags", {});
      let allProductTags = [];
      for (let index = 0; index < result.length; index++) {
        let newObject = {};
        newObject.value = result[index].id;
        newObject.label = result[index].title;
        allProductTags.push(newObject);
      }
      setAllProductTags(allProductTags);
    }
    loadPage();
  }, [updater]);
  useEffect(() => {
    let selectedtags = allProductTags.filter((value) => {
      for (let index = 0; index < product.tags.length; index++) {
        if (product.tags[index].id == value.value) return true;
      }
      return false;
    });
    setLocalArticleData({
      title: product.title,
      productId: product.id,
      description: product.description,
      score: product.sharePoint,
      hashtags: [...selectedtags],
      otherFiles: product.medias,
    });
  }, [updater, product]);

  async function getProducts() {
    setLoader(true);
    let result = await connection("getproducts", {
      shopSuffix: params.shop_suffix,
    });
    if (result.status == 1) {
      setProducts(result.result);
    }
    setLoader(false);
  }

  function deleteArticle() {
    Swal.fire({
      title: "آیا از حذف پست اطمینان دارید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "انصراف",
    }).then((result) => {
      if (result.isConfirmed) {
        connection("Delete_Products", {
          conditions: `id/=/${localArticleData.productId}`,
        }).then((data) => {
          console.log(localArticleData.productId, "del");
          if (data.status == 1) {
            Swal.fire("پست با موفقیت حذف شد.");
            btnRef.current.click();
            getProducts();
          } else {
            Swal.fire("مشکلی در حذف پست پیش آمده است.");
          }
        });
      }
    });
  }
  async function updateHandler(localArticleData) {
    let productTags = await Promise.all(
      localArticleData.hashtags.map(async (arrayItem) => {
        console.log("arrayItem", arrayItem);
        let id = arrayItem.value;
        if (arrayItem.__isNew__ == true) {
          let data = await connection("Insert_ProductTags", {
            title: arrayItem.label,
          });
          localArticleData.hashtags.push(data.result.id);
          id = data.result.id;
        } else {
          localArticleData.hashtags.push(+arrayItem.value);
        }
        return id;
      })
    );

    let coverx = localArticleData.coverId;
    let result = await connection("editproduct", {
      productId: localArticleData.productId,
      description: localArticleData.description,
      title: localArticleData.title,
      tagIds: productTags.join(","),
      sharePoint: localArticleData.score,
      coverImgId: coverx,
      mediaIds: localArticleData.otherFilesId
        .map((value) => value.id)
        .join(","),
    });

    if (result.status == -1) {
      setLocalArticleData({
        title: "",
        description: "",
        score: "",
        cover: null,
        hashtags: null,
        otherFiles: null,
      });
      console.log("result", result);
      if (result.status == -1 || result.status == 0) {
        toast.error("خطا در اعمال تغییرات!");
      } else {
        toast.success("تغییرات با موفقیت اعمال شد");
      }
    }
    //TODO:
    setUpdater(!updater);
    getProducts();
  }
  let admin = auth.userInfo.shopIds.find((value) => value.id == bpid);
  return (
    <>
      <div
        className="modal fade"
        id="SingleProduct"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalToggleLabel">
                محصول
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={btnRef}
              ></button>
            </div>
            <div className="modal-body row">
              <div className="col-12 col-md-10 col-lg-7 col-xl-6">
                <SingleProductSlider product={product} />
              </div>
              <div className="col-12 col-lg-5 content">
                <div>{product.title}</div>
                <div>
                  <ReactStars
                    count={5}
                    value={product.rate ? product.rate : 0}
                    size={24}
                    isHalf={true}
                    edit={false}
                    emptyIcon={<i className="far fa-star"></i>}
                    halfIcon={<i className="fa fa-star-half-alt"></i>}
                    fullIcon={<i className="fa fa-star"></i>}
                    activeColor="#ffd700"
                  />
                </div>
                <div>
                  <div
                    dangerouslySetInnerHTML={{ __html: product?.description }}
                  ></div>
                </div>
                {admin ? (
                  <div className="buttons mt-5">
                    <div
                      className="btn btn-success"
                      data-bs-target="#exampleModalToggle2"
                      data-bs-toggle="modal"
                      data-bs-dismiss="modal"
                    >
                      ویرایش
                    </div>
                    <div
                      className="btn btn-danger mx-3"
                      onClick={deleteArticle}
                    >
                      حذف
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {product.similarProducts.length != 0 ? (
                <div>
                  <Formatter header={"محصولات مرتبط"}>
                    <Swiper
                      style={{
                        "--swiper-navigation-color": "#586ba6",
                        "--swiper-pagination-color": "#586ba6",
                      }}
                      loop={true}
                      spaceBetween={10}
                      navigation={true}
                      // allowTouchMove={true}
                      slidesPerView={1}
                      freeMode={true}
                      watchSlidesProgress={true}
                    >
                      {product.similarProducts.map((value, index) => {
                        let SP = products.find((val) => val.id == value.id);
                        return (
                          <SwiperSlide key={index}>
                            <Product value={SP} key={index} isMain={false} />
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </Formatter>
                </div>
              ) : (
                ""
              )}
              {product.comments.length != 0 ? (
                <div>
                  <Formatter header={"نظرات کاربران"}>
                    <CreateComment isProduct={true} />
                    <CommentList commentLists={comments} />
                  </Formatter>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModalToggle2"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalToggleLabel2">
                {" "}
                ویرایش محصول
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <form>
                  <div className="row">
                    <label for="title" className="col-4">
                      نام محصول
                    </label>
                    <div className="col-8">
                      <input
                        type="text"
                        id="title"
                        className={` ${styles.inputt3} `}
                        value={localArticleData.title}
                        onChange={(e) => {
                          changeHandler("title", e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-4">
                      <label for="images">کاور محصول</label>
                    </div>
                    <div className="col-8">
                      <input
                        onChange={changeHandlerImg}
                        type="file"
                        id="images"
                        ref={inputRef}
                        name="cover"
                        className={`${styles.inputt3} `}
                        style={{
                          lineHeight: "35px",
                          paddingRight: "1px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-4">
                      <label for="otherFiles">فایل های جانبی </label>
                    </div>
                    <div
                      className="col-8"
                      style={{ height: "40px !important" }}
                    >
                      <input
                        type="file"
                        id="otherFiles"
                        onChange={changeHandlerLogo}
                        ref={inputRef}
                        name="otherFiles"
                        className={` ${styles.inputt3} `}
                        multiple
                        style={{
                          lineHeight: "35px",
                          paddingRight: "1px",
                        }}
                      />
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-4">
                      <label for="">امتیاز به ازای اشتراک</label>
                    </div>
                    <div className="col-8">
                      <input
                        type="number"
                        id="score"
                        className={` ${styles.inputt3} `}
                        value={localArticleData.score}
                        onChange={(e) => {
                          changeHandler("score", e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-4">
                      <label for="description">توضیحات</label>
                    </div>
                    <div className="col-8">
                      <Editor
                        setContents={localArticleData.description}
                        onChange={(e) => {
                          changeHandler("description", e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-4">
                      <label for="">برچسب</label>
                    </div>
                    <div className="col-8">
                      <Creatable
                        id="tags"
                        options={allProductTags}
                        value={localArticleData.hashtags}
                        onChange={changeHandleraTags}
                        // options={tagsOptions}
                        isMulti={true}
                        className={`mx-1 ${styles.inputt3} `}
                        // value={defaultTags}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                data-bs-target="#SingleProduct"
                data-bs-toggle="modal"
                data-bs-dismiss="modal"
                onClick={() => updateHandler(localArticleData)}
              >
                ثبت{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SingleProduct;
